import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import RingsIcon from "./images/rings.webp";

function Schedule() {
  return (
    <div className="bg-base">
      <div className="timeline p-top-8 p-bottom-8">
      <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
            <h5 className="m-bottom-1 font-body">локация</h5>
            <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">х-л “Теризис”</span>
              </h4>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end flex-justify-center-xsm">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">17:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">welcome drinks</h5>
              <i className="fa-solid m-top-1 fa-martini-glass-citrus m-right-1 text-xl" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-17"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">17:30</span>
              </h4>
              <h5 className="m-bottom-1 font-body">церемония</h5>
              <img
                  alt=""
                  src={RingsIcon}
                  style={{ width: 30 }}
                  className="flex text-xl m-left-auto m-right-auto"
                />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-17"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">18:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">снимки и поздравления</h5>
              <i className="fa-solid m-top-1 fa-camera-retro m-right-1 text-xl" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-18"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
      
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">19:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">настаняване за официална вечеря</h5>
              <i className="fa-solid m-top-1 fa-utensils m-right-1 text-xl" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-19"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end">
            <div className="content col-8 text-center">
         
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">19:30</span>
              </h4>
              <h5 className="m-bottom-1 font-body">посрещане на младоженците</h5>
              <i className="fa-solid m-top-1 fa-bullhorn m-right-1 text-xl" />
            </div>  
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-19"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">20:30</span>
              </h4>
              <h5 className="m-bottom-1 font-body">първи брачен танц</h5>
              <i className="fa-solid m-top-1 fa-music m-right-1 text-xl" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-20"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-primary font-body">22:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">торта</h5>
              <i className="fa-solid m-top-1 fa-cake-candles m-right-1 text-xl" />
            </div>  
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-22"></div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default Schedule;
